import React, {useEffect, useState} from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaMoneyCheck, FaUser, FaQuestionCircle, FaSignOutAlt, FaDownload } from 'react-icons/fa';
import { MdAdminPanelSettings } from "react-icons/md";
import { IoIosSettings } from "react-icons/io";
import logo from '../Assets/Images/VIZEdi-322x80-Tm.png';
import './CSS/SideNavbar.css';

const SideNavbar: React.FC = () => {
    const navigate = useNavigate();
    const [subscriptionType, setSubscriptionType] = useState<string | null>(null);


    const handleSignOut = () => {
        localStorage.clear();

        navigate('/login');
    };

    useEffect(() => {
        const storedSubscriptionType = localStorage.getItem('subscriptionType');

        setSubscriptionType(storedSubscriptionType);
    }, []);

    return (
        <nav className="side-navbar">
            <Link to="/account/profile" className="side-navbar-logo">
                <img src={logo} alt="Home" />
            </Link>
            <ul className="side-navbar-menu">
                <li>
                    <Link to="/account/profile" className="menu-item">
                        <FaUser className="menu-icon"/> Profile
                    </Link>
                </li>
                <li>
                    <Link to="/account/subscription" className="menu-item">
                        <FaMoneyCheck className="menu-icon"/> Subscription
                    </Link>
                </li>
                <li>
                    {subscriptionType === 'ENTERPRISE' && (
                        <li>
                            <Link to="/account/admin" className="menu-item">
                                <MdAdminPanelSettings className="menu-icon" /> Admin
                            </Link>
                        </li>
                    )}
                </li>
                <li>
                    <Link to="/account/applications" className="menu-item">
                        <FaDownload className="menu-icon"/> Applications
                    </Link>
                </li>
                <li>
                    <Link to="/account/settings" className="menu-item">
                        <IoIosSettings className="menu-icon"/> Settings
                    </Link>
                </li>
            </ul>
            <ul className="side-navbar-footer">
                <li>
                    <Link to="/customer-support" className="menu-item">
                        <FaQuestionCircle className="menu-icon" /> Support
                    </Link>
                </li>
                <li>
                    <Link to="/login" className="menu-item" onClick={handleSignOut}>
                        <FaSignOutAlt className="menu-icon" /> Sign Out
                    </Link>
                </li>
            </ul>
        </nav>
    );
};

export default SideNavbar;
